import React, { PureComponent } from "react";
import { ReactComponent as LocationIcon } from "../../components/assets/room-24px.svg";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

import loadable from "@loadable/component";
import styles from "./LocationOn.module.scss";

const FontAwesomeIcon = loadable(
  () => import("@fortawesome/react-fontawesome"),
  {
    resolveComponent: (components) => components.FontAwesomeIcon,
  }
);
library.add(fas);

export default class ClusteringLocationOn extends PureComponent {
  componentDidMount() {
    if (window.self !== window.top) {
      this.preventScroll();
    }
  }

  preventScroll = () => {
    if (this.markerRef) {
      this.markerRef.scrollIntoView = () => {};
    }
  };

  handleClick = (e) => {
    const { onClick } = this.props;
    e.preventDefault();
    e.stopPropagation();
    
    if (e.target) {
      e.target.blur();
    }
    
    if (onClick) {
      onClick(e);
    }
  };

  render() {
    const { onClick } = this.props;
    var color = "black"; 
    var tempIcon = null;
    const destinationEvent = this.props.destinationEvent;
    if (
      destinationEvent !== undefined &&
      destinationEvent.markerDetail !== undefined &&
      destinationEvent.markerDetail.color !== undefined
    ) {
      color = destinationEvent.markerDetail.color;
    }

    tempIcon = (
      <LocationIcon
        fill={color}
        onClick={this.handleClick}
        className={styles["LocationOn"]}
        alt="Location marker"
        ref={(ref) => (this.markerRef = ref)}
      />
    );

    if (destinationEvent !== undefined) {
      if (
        destinationEvent.markerDetail !== undefined &&
        destinationEvent.markerDetail.type !== undefined
      ) {
        if (
          destinationEvent.markerDetail.circleActive !== undefined &&
          destinationEvent.markerDetail.circleActive === true
        ) {
          tempIcon = (
            <div
              onClick={this.handleClick}
              className={styles["marker-container"]}
              style={{
                backgroundColor:
                  destinationEvent.markerDetail.activePrimaryColor,
              }}
              ref={(ref) => (this.markerRef = ref)}
            >
              <FontAwesomeIcon
                title={destinationEvent.markerDetail.text}
                icon={destinationEvent.markerDetail.type}
                color={destinationEvent.markerDetail.activeSecondaryColor}
                style={{
                  width: "1rem",
                  height: "1rem",
                }}
              />
            </div>
          );
        } else {
          tempIcon = (
            <FontAwesomeIcon
              className={styles["Default-layer-3x"]}
              icon={destinationEvent.markerDetail.type}
              onClick={this.handleClick}
              fixedWidth
              style={{
                fontSize: "43px",
              }}
              color={color}
            />
          );
        }
      }
    }

    return tempIcon;
  }
}
